import React, { useEffect, useRef, useState, createRef } from "react";
import BusinessRulesPreview from "components/businessrules/BusinessRlsPreview";
import SingleLinekeyValue from "components/SingleLineKeyValue";
import OverlayPopOver from "Uitls/OverlayPopOver";
import { ToolTipText } from "components/TooltipText";
import "styles/modules/modulePreview.scss";
import chackbox from "img/genai/cardstatus.svg";
import styles from "styles/genai/Edetail.module.scss";
import { toggleMustUse } from "services/apis";
import bulbIcon from "img/genai/bulb.svg";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
const popoverRef = createRef();

// Add the usage options
const usageOptions = [
  { id: 1, displayName: "Must Use", veevaId: "must_use", color: "#E32B35" },
  { id: 2, displayName: "Optional", veevaId: "optional", color: "#378A05" },
];

// Simple Usage Dropdown Component
const SimpleUsageDropdown = ({ value, onChange, iconSrc }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "relative",
        display: "inline-block",
        border: "1px solid #D4D4D4",
        borderRadius: "6px",
        padding: "2px 6px",
      }}
    >
      <div
        onClick={toggleDropdown}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          position: "relative",
        }}
      >
        <span>
          <img src={iconSrc} alt="" />
        </span>{" "}
        <span>{value?.displayName}</span>
        <span style={{ color: "#203662", fontSize: "12px", marginLeft: "4px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="10px"
            height="10px"
            fill="#203662"
          >
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          </svg>
        </span>
      </div>

      {isOpen && (
        <div
          className="usageDropdownOptionsMain"
          style={{
            width: value?.id === usageOptions[0].id ? "117px" : "112px",
          }}

          // style={{
          //   position: "absolute",
          //   top: "calc(100% + 4px)",
          //   left: "-2px",
          //   backgroundColor: "white",
          //   borderRadius: "6px",
          //   border: "1px solid rgb(224, 224, 224)",
          //   boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
          //   zIndex: 999,
          //   overflow: "hidden",
          //   height: "36px",
          //   display: "flex",
          //   flexDirection: "column",
          //   justifyContent: "center",
          //   alignItems: "center",
          //   width: "112px",
          // }}
        >
          {usageOptions.map((option) => (
            <div
              key={option.id}
              onClick={() => handleSelect(option)}
              className="usageChild"
              style={
                {
                  // backgroundColor:
                  //   value?.id === option.id ? "#F0F5F8" : "#ffffff",
                }
              }
            >
              <div
                className="usageBoxChild"
                style={{
                  // width: "12px",
                  // height: "12px",
                  backgroundColor: option.color,
                  // borderRadius: "3px",
                  // marginRight: "8px",
                  // flexShrink: 0,
                }}
              />
              <span style={{ fontSize: "14px", color: "#333" }}>
                {option.displayName}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const openVeevaVault = (url) => {
  window.open(url, "_blank");
};
// Add a helper function to get the correct icon based on the usage type
const getUsageTypeIcon = (usageType) => {
  // If usageType is an object with veevaId
  if (usageType && typeof usageType === "object" && usageType.veevaId) {
    return usageType.veevaId === "must_use"
      ? "mustUseRedDot.svg"
      : "mustUseGreenDot.svg";
  }
  // If usageType is a boolean
  if (typeof usageType === "boolean") {
    return usageType ? "mustUseRedDot.svg" : "mustUseGreenDot.svg";
  }
  // Default to optional (green) if unknown
  return "mustUseGreenDot.svg";
};

function ModulePreviewData(props) {
  const {
    modulePreviewData,
    isBussinessRulesView,
    activePreviwData,
    generatePdf,
    onlyClaimCardsVisible = false,
    openedFromModal = false,
    selectedItems = { claims: [], reusableTexts: [], components: [] },
    setSelectedItems,
    onUsageTypeChange,
    isSlide,
    onElementDeselect,
    hideMustUseLabels = false,
    moduleId,
    currentModule,
    edtInfo,
  } = props;

  // Simple state to track selected claims - use a ref to prevent unintended resets
  const selectedClaimsRef = useRef([]);
  // Track usage types for each item, keyed by moduleId to maintain separate states
  const [itemUsageTypes, setItemUsageTypes] = useState({});
  // Keep track of initialized modules
  const initializedModulesRef = useRef(new Set());

  const { showEdt, edetailDetails } = edtInfo || {
    showEdt: false,
    edetailDetails: "",
  };
  // Debug counter for tracking re-renders
  const renderCountRef = useRef(0);
  useEffect(() => {
    // Early return if critical props are missing
    if (
      typeof setSelectedItems !== "function" ||
      !modulePreviewData ||
      !currentModule
    ) {
      return;
    }

    // Skip if already initialized for this module
    if (initializedModulesRef.current.has(currentModule)) {
      return;
    }

    // Get all available element IDs
    const allClaims =
      modulePreviewData.claims?.map((claim) => claim.claimName) || [];
    const allReusableTexts =
      modulePreviewData.reusableTexts?.map((rt) => rt.reusableTextName) || [];
    const allComponents =
      modulePreviewData.components?.map((comp) => comp.componentDocNumber) ||
      [];

    // Only initialize if we have elements and none are currently selected
    const shouldInitialize =
      (allClaims.length > 0 ||
        allReusableTexts.length > 0 ||
        allComponents.length > 0) &&
      selectedItems.claims.length === 0 &&
      selectedItems.reusableTexts.length === 0 &&
      selectedItems.components.length === 0;

    if (shouldInitialize) {
      setSelectedItems({
        claims: allClaims,
        reusableTexts: allReusableTexts,
        components: allComponents,
      });
      initializedModulesRef.current.add(currentModule);
    }
  }, [modulePreviewData, selectedItems, setSelectedItems, currentModule]);

  // Count renders to debug unintended component updates
  useEffect(() => {
    renderCountRef.current += 1;
    // console.log(`ModulePreviewData rendered ${renderCountRef.current} times`);
  });

  // Initialize and update usage types with moduleId as a key
  useEffect(() => {
    // Skip if no modulePreviewData
    if (!modulePreviewData || !moduleId) {
      return;
    }

    // console.log(`Initializing or updating usage types for module ${moduleId}`);

    // Create a copy of the current state
    const updatedUsageTypes = { ...itemUsageTypes };

    // If we don't have an entry for this moduleId yet, create one
    if (!updatedUsageTypes[moduleId]) {
      updatedUsageTypes[moduleId] = {};
    }

    // Update for claims - always update based on the latest data
    if (modulePreviewData?.claims) {
      modulePreviewData.claims.forEach((claim) => {
        // Always use the latest mustUse value from the modulePreviewData
        updatedUsageTypes[moduleId][claim.claimName] = claim.mustUse
          ? usageOptions[0]
          : usageOptions[1];
      });
    }

    // Update for reusable texts - always update based on the latest data
    if (modulePreviewData?.reusableTexts) {
      modulePreviewData.reusableTexts.forEach((text) => {
        // Always use the latest mustUse value from the modulePreviewData
        updatedUsageTypes[moduleId][text.reusableTextName] = text.mustUse
          ? usageOptions[0]
          : usageOptions[1];
      });
    }

    // Update for components - always update based on the latest data
    if (modulePreviewData?.components) {
      modulePreviewData.components.forEach((component) => {
        // Always use the latest mustUse value from the modulePreviewData
        updatedUsageTypes[moduleId][component.componentDocNumber] =
          component.mustUse ? usageOptions[0] : usageOptions[1];
      });
    }

    // Update the state with the new values
    setItemUsageTypes(updatedUsageTypes);
  }, [modulePreviewData, moduleId]);

  // When modulePreviewData or selectedItems changes, update the selected state of items
  useEffect(() => {
    if (modulePreviewData?.claims) {
      modulePreviewData.claims.forEach((claim) => {
        claim.isSelected = selectedItems?.claims?.includes(claim.claimId);
      });
    }

    if (modulePreviewData?.reusableTexts) {
      modulePreviewData.reusableTexts.forEach((text) => {
        text.isSelected = selectedItems?.reusableTexts?.includes(
          text.reusableTextId,
        );
      });
    }

    if (modulePreviewData?.components) {
      modulePreviewData.components.forEach((component) => {
        component.isSelected = selectedItems?.components?.includes(
          component.componentId,
        );
      });
    }
  }, [modulePreviewData, selectedItems]);

  // useEffect(() => {
  //   console.log("selectedItems", selectedItems);
  // }, [selectedItems]);

  const handleClaimSelect = (claimId) => {
    // console.log("handleClaimSelect", claimId);

    let arrSelectedItems = [...selectedItems?.claims];

    if (arrSelectedItems.includes(claimId)) {
      // Item is being deselected
      arrSelectedItems = arrSelectedItems.filter((item) => item !== claimId);
      // Notify parent component about deselection if handler exists
      if (onElementDeselect) {
        onElementDeselect("claims", claimId);
      }
    } else {
      arrSelectedItems.push(claimId);
    }

    setSelectedItems({ ...selectedItems, claims: arrSelectedItems });
  };

  const handleReusableSelect = (reusableId) => {
    // console.log("handleReusableSelect", reusableId);

    let arrSelectedItems = [...selectedItems?.reusableTexts];

    if (arrSelectedItems.includes(reusableId)) {
      // Item is being deselected
      arrSelectedItems = arrSelectedItems.filter((item) => item !== reusableId);
      // Notify parent component about deselection if handler exists
      if (onElementDeselect) {
        onElementDeselect("reusableTexts", reusableId);
      }
    } else {
      arrSelectedItems.push(reusableId);
    }

    setSelectedItems({ ...selectedItems, reusableTexts: arrSelectedItems });
  };

  const handleComponentSelect = (componentId) => {
    // console.log("handleComponentSelect", componentId);

    let arrSelectedItems = [...selectedItems?.components];

    if (arrSelectedItems.includes(componentId)) {
      // Item is being deselected
      arrSelectedItems = arrSelectedItems.filter(
        (item) => item !== componentId,
      );
      // Notify parent component about deselection if handler exists
      if (onElementDeselect) {
        onElementDeselect("components", componentId);
      }
    } else {
      arrSelectedItems.push(componentId);
    }

    setSelectedItems({ ...selectedItems, components: arrSelectedItems });
  };

  // Handle usage type changes - updated to use moduleId
  const handleUsageTypeChange = async (
    itemId,
    usageType,
    elementType,
    value,
  ) => {
    // console.log(
    //   `Changing usage type for ${itemId} in module ${moduleId}:`,
    //   usageType
    // );

    // Update local state to immediately reflect changes in UI
    setItemUsageTypes((prev) => {
      // Create a copy of the current state
      const updated = { ...prev };

      // If we don't have an entry for this moduleId yet, create one
      if (!updated[moduleId]) {
        updated[moduleId] = {};
      }

      // Update the specific item's usage type for this module
      updated[moduleId][itemId] = value;

      return updated;
    });

    // Notify parent component if handler exists so it can update the moduleElements state
    if (onUsageTypeChange) {
      onUsageTypeChange(itemId, usageType, elementType, value);
    }
  };

  const reusableTextTypes = [
    {
      name: "copy__v",
      label: "Copy",
    },
    {
      name: "headline__v",
      label: "Headline",
    },
    {
      name: "objective__v",
      label: "Objective",
    },
    {
      name: "strapline__v",
      label: "Strapline",
    },
    {
      name: "summary__v",
      label: "Summary",
    },
    {
      name: "tagline__v",
      label: "Tagline",
    },
    {
      name: "teaser__v",
      label: "Teaser",
    },
    {
      name: "title__v",
      label: "Title",
    },
  ];

  function getLabelByName(name) {
    const item = reusableTextTypes.find((item) => item.name === name);
    return item ? item.label : null;
  }
  const getSvgCDNLinks = (fileName) => {
    return modulePreviewData?.logos?.find((item) => item.includes(fileName));
  };
  const getMlrStatusIcon = (mlrStatus) => {
    if (!mlrStatus) return getSvgCDNLinks("infoIcon.svg");

    const trimmedStatus = mlrStatus.trim().toLowerCase();

    if (trimmedStatus.includes("draft")) {
      return getSvgCDNLinks("statusDraft.svg");
    } else if (trimmedStatus.includes("available")) {
      return getSvgCDNLinks("statusApproved.svg");
    } else if (trimmedStatus.includes("expired")) {
      return getSvgCDNLinks("final-status.svg");
    } else {
      return getSvgCDNLinks("Intermediate.svg");
    }
  };
  const ClaimDetailsBox = ({ component, children }) => {
    // Calculate hasOnlyImage inside the component using the prop
    const hasOnlyImage =
      !component?.trackChangeValue &&
      !component?.title &&
      !component?.matchText &&
      !component?.relatedClaims?.length;

    return (
      <div className={hasOnlyImage ? "claimDetailsBoxMain" : "claimDetailsBox"}>
        {children}
      </div>
    );
  };

  const geaiStyle = {
    ...(edtInfo?.showEdt || isSlide
      ? {
          width: "804px",
          minWidth: "804px",
          maxWidth: "804px",
          background: "#ffffff",
          borderRadius: "12px",
          margin: "20px",
          ...(isSlide ? { padding: "0px 20px" } : {}),
        }
      : {}),
  };

  return (
    <>
      <div
        id="modulePreviewContainer"
        className={
          onlyClaimCardsVisible
            ? "m-0  p-0"
            : `pdfPreviewWidth ${isSlide ? "" : "mt-4"}`
        }
        style={geaiStyle}
      >
        <div
          className={`col-12 p-0 ${
            !activePreviwData ? "cmsdTrackContainer" : null
          }`}
        >
          <div className="modulePreviewContainer">
            {(showEdt ||
              (modulePreviewData.eDetailDocUrl &&
                !hideMustUseLabels &&
                !onlyClaimCardsVisible)) && (
              <div className="edetailBoxPreview">
                <span>
                  <img src={getSvgCDNLinks("infoIcon.svg")} alt="info" />
                  Module was generated from{" "}
                  <img
                    src={getSvgCDNLinks("statusApproved.svg")}
                    alt="approved"
                  />
                  <strong
                    onClick={() => {
                      const docUrl =
                        edetailDetails?.eDetailDocUrl ||
                        modulePreviewData?.eDetailDocUrl;
                      docUrl && openVeevaVault(docUrl);
                    }}
                    className={"edetailLink"}
                  >
                    {edetailDetails?.eDetailSourceDocNum ||
                      modulePreviewData?.eDetailSourceDocNum ||
                      "N/A"}
                  </strong>
                </span>
              </div>
            )}
            {generatePdf || onlyClaimCardsVisible || isSlide ? null : (
              <div className="modulePreviewHeader">
                <p style={{ lineHeight: "1.6" }}>
                  {modulePreviewData?.countryName && (
                    <>
                      <span className="ml-0">Primary Product:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.productName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.productName && (
                    <>
                      <span>Primary Country:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.countryName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.indications?.length > 0 && (
                    <>
                      <span>Indication:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.indications
                          ?.map((indication) => indication.indicationName)
                          .join(", ")}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.languageName && (
                    <>
                      <span>Language:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.languageName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.topicName && (
                    <>
                      <span>Topic:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.topicName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.subtopicName && (
                    <>
                      <span>Sub-Topic:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.subtopicName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.audienceName && (
                    <>
                      <span>Audience:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.audienceName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.therapeuticAreaName && (
                    <>
                      <span>Therapeutic Area:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.therapeuticAreaName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.segments?.length > 0 && (
                    <>
                      <span>Segment:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData.segments
                          .map((segment) => segment.segmentName)
                          .join(", ")}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.strategicObjectives?.length > 0 && (
                    <>
                      <span>Strategic Objective:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.strategicObjectives
                          ?.map((objective) => objective.strategicObjName)
                          .join(", ")}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.contentToneName?.length > 0 && (
                    <>
                      <span>Content Tone:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.contentToneName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.creativeAgencyName?.length > 0 && (
                    <>
                      <span className="ml-0">Creative Agency:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.creativeAgencyName}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.moduleDraftElementIncluded?.length >
                    0 && (
                    <>
                      <span>Draft Elements Included?:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.moduleDraftElementIncluded?.map(
                          (indication, index, array) => (
                            <>
                              {indication.draftElementIncludedName}
                              {index < array.length - 1 ? ", " : ""}
                            </>
                          ),
                        )}
                      </span>{" "}
                    </>
                  )}
                  {modulePreviewData?.communicationObjectives && (
                    <>
                      <span>Communication Objectives:</span>{" "}
                      <span className="headerValue_mp">
                        {modulePreviewData?.communicationObjectives}
                      </span>
                    </>
                  )}
                </p>
              </div>
            )}

            {modulePreviewData?.claims &&
              modulePreviewData?.claims?.map((claim) => (
                <React.Fragment key={claim.claimId}>
                  {claim.trackChangeValue && (
                    <div>
                      <span
                        className={
                          claim.trackChangeValue === "new"
                            ? "newData"
                            : claim.trackChangeValue === "old"
                              ? "newData oldData"
                              : ""
                        }
                      >
                        {claim.trackChangeValue}
                      </span>
                    </div>
                  )}
                  <div
                    className={`d-flex ${
                      onlyClaimCardsVisible ? "align-items-center" : ""
                    } moduleClaimSection ${
                      claim.trackChangeValue === "new"
                        ? "trackChangeValue"
                        : claim.trackChangeValue === "old"
                          ? "trackChangeValue old"
                          : ""
                    }`}
                  >
                    {onlyClaimCardsVisible && (
                      <div style={{ display: "flex", margin: "0 10px" }}>
                        <CheckBoxComponent
                          item={claim}
                          isSelected={selectedItems?.claims?.includes(
                            claim.claimName,
                          )}
                          handleSelectedItem={() =>
                            handleClaimSelect(claim.claimName)
                          }
                        />
                      </div>
                    )}
                    <div>
                      <div className={`d-flex align-items-center`}>
                        <div
                          className={`claimBoxOuterContainer ${
                            claim?.mlrStatus === "Available for Use"
                              ? "approved"
                              : "notApproved"
                          }`}
                        >
                          <div
                            className={`claimBoxBrdr ${
                              claim?.mlrStatus === "Available for Use"
                                ? "with-border"
                                : ""
                            }`}
                          >
                            <div className="claimType">CLAIM</div>
                            {!hideMustUseLabels && (
                              <div className="damStatus">
                                {onlyClaimCardsVisible ? (
                                  <SimpleUsageDropdown
                                    iconSrc={getSvgCDNLinks(
                                      getUsageTypeIcon(
                                        itemUsageTypes[moduleId]?.[
                                          claim.claimName
                                        ] ||
                                          (claim.mustUse
                                            ? usageOptions[0]
                                            : usageOptions[1]),
                                      ),
                                    )}
                                    value={
                                      itemUsageTypes[moduleId]?.[
                                        claim.claimName
                                      ] ||
                                      (claim.mustUse
                                        ? usageOptions[0]
                                        : usageOptions[1])
                                    }
                                    onChange={(value) =>
                                      handleUsageTypeChange(
                                        claim.claimName,
                                        claim.mustUse,
                                        "claims",
                                        value,
                                      )
                                    }
                                  />
                                ) : claim.mustUse ? (
                                  <>
                                    <span>
                                      <img
                                        src={getSvgCDNLinks(
                                          "mustUseRedDot.svg",
                                        )}
                                        alt=""
                                      />
                                    </span>{" "}
                                    <span>Must Use</span>
                                  </>
                                ) : (
                                  <>
                                    <span>
                                      <img
                                        src={getSvgCDNLinks(
                                          "mustUseGreenDot.svg",
                                        )}
                                        alt=""
                                      />
                                    </span>{" "}
                                    <span>Optional</span>
                                  </>
                                )}
                              </div>
                            )}

                            <div className="claimId">
                              PromoMats ID:{" "}
                              <span>
                                <span>
                                  {modulePreviewData?.countryName ===
                                  "United States" ? (
                                    <>
                                      {!hideMustUseLabels && <></>}
                                      {claim?.claimName}
                                    </>
                                  ) : (
                                    <>
                                      {!hideMustUseLabels && (
                                        <OverlayPopOver
                                          element={
                                            <img
                                              src={getMlrStatusIcon(
                                                claim?.mlrStatus,
                                              )}
                                              alt={claim?.mlrStatus}
                                            />
                                          }
                                          overlayData={
                                            <ToolTipText>
                                              {claim?.mlrStatus
                                                ? claim?.mlrStatus
                                                : "Module not Published"}
                                            </ToolTipText>
                                          }
                                          trigger={["hover", "focus"]}
                                          placement="bottom"
                                          classId="tooltip"
                                          containerRef={popoverRef}
                                        />
                                      )}
                                      {claim?.claimName}
                                    </>
                                  )}
                                </span>
                              </span>
                            </div>
                          </div>
                          {hideMustUseLabels || onlyClaimCardsVisible
                            ? claim.mlrStatus == "Available for Use" && (
                                <ApprovedComp />
                              )
                            : null}
                          {/* {onlyClaimCardsVisible && <ApprovedComp />} */}
                          {modulePreviewData?.countryName ===
                            "United States" && (
                            <div className="mlrStatus-Block">
                              <img
                                src={getMlrStatusIcon(claim?.mlrStatus)}
                                alt={claim?.mlrStatus}
                              />
                              <span style={{ marginLeft: "5px" }}>
                                {claim?.mlrStatus}
                              </span>
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            ...((isSlide ||
                              onlyClaimCardsVisible ||
                              edtInfo?.showEdt) && {
                              width: "50px",
                            }),
                          }}
                        >
                          <img
                            style={{
                              ...((isSlide ||
                                onlyClaimCardsVisible ||
                                edtInfo?.showEdt) && {
                                width: "90%",
                              }),
                            }}
                            src={getSvgCDNLinks("modulePreviewArrow.svg")}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="claimDetailsBox"> */}
                    <div
                      className={
                        claim.relatedClaims?.length > 0 ||
                        claim.matchTextVariants?.length > 0 ||
                        claim.footnotes?.length > 0 ||
                        claim.references.length > 0
                          ? "claimDetailsBox"
                          : "claimDetailsBoxMain"
                      }
                    >
                      <p className="mb-0 claimText">{claim.matchText}</p>

                      {claim.matchTextVariants &&
                        claim.matchTextVariants.map((variant, index) => (
                          <React.Fragment key={index}>
                            <p className="captionText">Variation {index + 1}</p>
                            <p className="mb-0 claimText">
                              {" "}
                              {variant.matchText}
                            </p>
                          </React.Fragment>
                        ))}

                      {claim.footnotes && (
                        <p className="captionText">Footnote</p>
                      )}
                      <p className="relatedText">{claim.footnotes}</p>
                      {claim.abbreviation && (
                        <p className="captionText">Abbreviations</p>
                      )}
                      <p className="relatedText">{claim.abbreviation}</p>
                      {claim.references.length > 0 && (
                        <p className="captionText">Reference</p>
                      )}
                      <div className="relatedTextRef">
                        {claim.references.map((reference, refIndex) => (
                          <span
                            className="d-block"
                            // style={{ marginBottom: "5px" }}
                            key={refIndex}
                          >
                            {refIndex + 1}.{reference.documentName}
                          </span>
                        ))}
                      </div>
                      {/* relatedClaims */}
                      {claim.relatedClaims?.length > 0 && (
                        <>
                          <p className="captionText">
                            Related Claims ({claim.relatedClaims?.length})
                          </p>
                          <div className="relatedText">
                            {claim.relatedClaims?.map(
                              (relatedClaim, claimIndex) => (
                                <div
                                  style={{ marginBottom: "20px" }}
                                  key={claimIndex}
                                >
                                  {/* Claim ID and Status */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      className="mr-1"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      ID:
                                    </span>
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        marginRight: "4px",
                                        marginLeft: "3px",
                                      }}
                                    >
                                      <OverlayPopOver
                                        element={
                                          <img
                                            src={getMlrStatusIcon(
                                              relatedClaim.mlrStatus,
                                            )}
                                            alt={relatedClaim.mlrStatus}
                                          />
                                        }
                                        overlayData={
                                          <ToolTipText>
                                            {relatedClaim.mlrStatus
                                              ? relatedClaim.mlrStatus
                                              : "Module not Published"}
                                          </ToolTipText>
                                        }
                                        trigger={["hover", "focus"]}
                                        placement="bottom"
                                        classId="tooltip"
                                        containerRef={popoverRef}
                                      />
                                    </div>
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {relatedClaim.claimName}
                                    </span>
                                    {relatedClaim?.mlrStatus
                                      ?.trim()
                                      .toLowerCase()
                                      .includes("expired") && (
                                      <span
                                        className="Expired"
                                        style={{
                                          verticalAlign: "middle",
                                          marginLeft: "8px",
                                        }}
                                      >
                                        Expired
                                      </span>
                                    )}
                                  </div>
                                  {/* Match Text */}
                                  {relatedClaim.matchText && (
                                    <p
                                      className="mb-0 claimText"
                                      style={{ marginTop: "12px" }}
                                    >
                                      {relatedClaim.matchText}
                                    </p>
                                  )}
                                  {/* Footnotes Section */}
                                  {relatedClaim.footnotes && (
                                    <>
                                      <p
                                        className="captionText"
                                        style={{
                                          marginTop: "8px",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        Footnote
                                      </p>
                                      <p className="relatedText">
                                        {relatedClaim.footnotes}
                                      </p>
                                    </>
                                  )}
                                  {/* abbreviation */}
                                  {relatedClaim.abbreviation && (
                                    <>
                                      <p
                                        className="captionText"
                                        style={{
                                          marginTop: "8px",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        Abbreviations
                                      </p>
                                      <p className="relatedText">
                                        {relatedClaim.abbreviation}
                                      </p>
                                    </>
                                  )}
                                  {/* References Section */}
                                  {relatedClaim.references?.length > 0 && (
                                    <>
                                      <p
                                        className="captionText"
                                        style={{
                                          marginTop: "8px",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        Reference
                                      </p>
                                      <div className="relatedTextRef">
                                        <ol
                                          style={{
                                            paddingLeft: "0",
                                            marginLeft: "1em",
                                          }}
                                        >
                                          {relatedClaim.references.map(
                                            (reference, refIndex) => (
                                              <li key={`ref-${refIndex}`}>
                                                {reference.documentName}
                                              </li>
                                            ),
                                          )}
                                        </ol>
                                      </div>
                                    </>
                                  )}
                                  {/* Usage in final material */}
                                  {relatedClaim.usageInFinalMaterial && (
                                    <>
                                      <p
                                        className="captionText"
                                        style={{
                                          marginTop: "8px",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        Usage in final material
                                      </p>
                                      <p className="relatedText">
                                        {relatedClaim.usageInFinalMaterial}
                                      </p>
                                    </>
                                  )}
                                </div>
                              ),
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            {!onlyClaimCardsVisible &&
              modulePreviewData?.claims?.length > 0 && (
                <div className="sectionDevider"></div>
              )}

            {/* Rest of the component remains unchanged */}
            {modulePreviewData?.reusableTexts?.length > 0 && (
              <>
                {modulePreviewData?.reusableTexts?.map(
                  (reusableText, index) => (
                    <div key={index}>
                      {reusableText.trackChangeValue && (
                        <div>
                          <span
                            className={
                              reusableText.trackChangeValue === "new"
                                ? "newData"
                                : reusableText.trackChangeValue === "old"
                                  ? "newData oldData"
                                  : ""
                            }
                          >
                            {reusableText.trackChangeValue}
                          </span>
                        </div>
                      )}
                      <div
                        className={`d-flex align-items-center moduleClaimSection ${
                          // className={`d-flex align- moduleClaimSection ${
                          reusableText.trackChangeValue === "new"
                            ? "trackChangeValue"
                            : reusableText.trackChangeValue === "old"
                              ? "trackChangeValue old"
                              : ""
                        }`}
                      >
                        {onlyClaimCardsVisible && (
                          <div style={{ display: "flex", margin: "0 10px" }}>
                            <CheckBoxComponent
                              isComponentTrue={true}
                              item={reusableText}
                              isSelected={selectedItems?.reusableTexts?.includes(
                                reusableText.reusableTextName,
                              )}
                              handleSelectedItem={() =>
                                handleReusableSelect(
                                  reusableText.reusableTextName,
                                )
                              }
                            />
                          </div>
                        )}
                        <div className={`d-flex align-items-center`}>
                          <div
                            className={`claimBoxOuterContainer ${
                              reusableText?.mlrStatus === "Available for Use"
                                ? "approved"
                                : "notApproved"
                            }`}
                          >
                            <div className="claimBoxBrdr">
                              <div className="claimType">Reusable text</div>
                              {!hideMustUseLabels && (
                                <div className="damStatus">
                                  {onlyClaimCardsVisible ? (
                                    <SimpleUsageDropdown
                                      iconSrc={getSvgCDNLinks(
                                        getUsageTypeIcon(
                                          itemUsageTypes[moduleId]?.[
                                            reusableText.reusableTextName
                                          ] ||
                                            (reusableText.mustUse
                                              ? usageOptions[0]
                                              : usageOptions[1]),
                                        ),
                                      )}
                                      value={
                                        itemUsageTypes[moduleId]?.[
                                          reusableText.reusableTextName
                                        ] ||
                                        (reusableText.mustUse
                                          ? usageOptions[0]
                                          : usageOptions[1])
                                      }
                                      onChange={(value) =>
                                        handleUsageTypeChange(
                                          reusableText.reusableTextName,
                                          reusableText.mustUse,
                                          "reusableTexts",
                                          value,
                                        )
                                      }
                                    />
                                  ) : (
                                    <>
                                      <span>
                                        <img
                                          src={getSvgCDNLinks(
                                            reusableText.mustUse
                                              ? "mustUseRedDot.svg"
                                              : "mustUseGreenDot.svg",
                                          )}
                                          alt=""
                                        />
                                      </span>{" "}
                                      <span>
                                        {reusableText.mustUse
                                          ? "Must Use"
                                          : "Optional"}
                                      </span>
                                    </>
                                  )}
                                </div>
                              )}

                              <div className="claimTypeText">
                                Type: <span>{reusableText.textType}</span>
                              </div>

                              <div className="claimId">
                                PromoMats ID:{" "}
                                <span>
                                  <>
                                    {!hideMustUseLabels &&
                                      modulePreviewData?.countryName !==
                                        "United States" && (
                                        <OverlayPopOver
                                          element={
                                            <img
                                              src={getMlrStatusIcon(
                                                reusableText?.mlrStatus,
                                              )}
                                              alt={reusableText?.mlrStatus}
                                            />
                                          }
                                          overlayData={
                                            <ToolTipText>
                                              {reusableText?.mlrStatus
                                                ? reusableText?.mlrStatus
                                                : "Module not Published"}
                                            </ToolTipText>
                                          }
                                          trigger={["hover", "focus"]}
                                          placement="bottom"
                                          classId="tooltip"
                                          containerRef={popoverRef}
                                        />
                                      )}
                                    {reusableText.reusableTextName}
                                  </>
                                </span>
                              </div>
                            </div>
                            {hideMustUseLabels || onlyClaimCardsVisible
                              ? reusableText.mlrStatus ==
                                  "Available for Use" && <ApprovedComp />
                              : null}
                            {/* {onlyClaimCardsVisible && <ApprovedComp />} */}
                            {modulePreviewData?.countryName ===
                              "United States" && (
                              <div className="mlrStatus-Block">
                                <img
                                  src={getMlrStatusIcon(
                                    reusableText?.mlrStatus,
                                  )}
                                  alt={reusableText?.mlrStatus}
                                />
                                <span style={{ marginLeft: "5px" }}>
                                  {reusableText?.mlrStatus}
                                </span>
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              ...((isSlide ||
                                onlyClaimCardsVisible ||
                                edtInfo?.showEdt) && {
                                width: "50px",
                              }),
                            }}
                          >
                            <img
                              style={{
                                ...((isSlide ||
                                  onlyClaimCardsVisible ||
                                  edtInfo?.showEdt) && {
                                  width: "90%",
                                }),
                              }}
                              src={getSvgCDNLinks("modulePreviewArrow.svg")}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="claimDetailsBox">
                          <div>
                            {reusableText.textType !== "call_to_action__c" ? (
                              <>
                                <p className="mb-0 claimText">
                                  {reusableText.matchText}
                                </p>
                                {reusableText.matchTextVariants &&
                                  reusableText.matchTextVariants.map(
                                    (variant, index) => (
                                      <>
                                        <p className="captionText">
                                          Variation {index + 1}
                                        </p>
                                        <p className="mb-0 claimText">
                                          {" "}
                                          {variant.matchText}
                                        </p>
                                      </>
                                    ),
                                  )}
                              </>
                            ) : (
                              <>
                                <p className="mb-0 claimText">
                                  {reusableText.matchText}
                                </p>
                                <p className="captionText">Link</p>
                                <p className="relatedText"> </p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
                {!onlyClaimCardsVisible &&
                  modulePreviewData?.reusableTexts?.length > 0 && (
                    <div className="sectionDevider"></div>
                  )}
              </>
            )}
            {modulePreviewData?.components?.length > 0 &&
              modulePreviewData?.components.map((component, index) => (
                <div className="d-flex moduleClaimSection" key={index}>
                  <div>
                    <div className="d-flex align-items-center">
                      {onlyClaimCardsVisible && (
                        <div style={{ display: "flex", margin: "0 10px" }}>
                          <CheckBoxComponent
                            isComponentTrue={true}
                            item={component}
                            isSelected={selectedItems?.components?.includes(
                              component.componentDocNumber,
                            )}
                            handleSelectedItem={() =>
                              handleComponentSelect(
                                component.componentDocNumber,
                              )
                            }
                          />
                        </div>
                      )}
                      <div
                        className={`claimBoxOuterContainer ${
                          component?.mlrStatus === "Available for Use"
                            ? "approved"
                            : "notApproved"
                        }`}
                      >
                        <div className="claimBoxBrdr">
                          <div className="claimType">Component</div>
                          {!hideMustUseLabels && (
                            <div className="damStatus">
                              {component.mustUse ? (
                                <div className="damStatus">
                                  {onlyClaimCardsVisible ? (
                                    <SimpleUsageDropdown
                                      iconSrc={getSvgCDNLinks(
                                        getUsageTypeIcon(
                                          itemUsageTypes[moduleId]?.[
                                            component.componentDocNumber
                                          ] ||
                                            (component.mustUse
                                              ? usageOptions[0]
                                              : usageOptions[1]),
                                        ),
                                      )}
                                      value={
                                        itemUsageTypes[moduleId]?.[
                                          component.componentDocNumber
                                        ] ||
                                        (component.mustUse
                                          ? usageOptions[0]
                                          : usageOptions[1])
                                      }
                                      onChange={(value) =>
                                        handleUsageTypeChange(
                                          component.componentDocNumber,
                                          component.mustUse,
                                          "components",
                                          value,
                                        )
                                      }
                                    />
                                  ) : (
                                    <>
                                      <span>
                                        <img
                                          src={getSvgCDNLinks(
                                            "mustUseRedDot.svg",
                                          )}
                                          alt=""
                                        />
                                      </span>{" "}
                                      <span>Must Use</span>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <div className="damStatus">
                                  {onlyClaimCardsVisible ? (
                                    <SimpleUsageDropdown
                                      iconSrc={getSvgCDNLinks(
                                        getUsageTypeIcon(
                                          itemUsageTypes[moduleId]?.[
                                            component.componentDocNumber
                                          ] ||
                                            (component.mustUse
                                              ? usageOptions[0]
                                              : usageOptions[1]),
                                        ),
                                      )}
                                      value={
                                        itemUsageTypes[moduleId]?.[
                                          component.componentDocNumber
                                        ] ||
                                        (component.mustUse
                                          ? usageOptions[0]
                                          : usageOptions[1])
                                      }
                                      onChange={(value) =>
                                        handleUsageTypeChange(
                                          component.componentDocNumber,
                                          component.mustUse,
                                          "components",
                                          value,
                                        )
                                      }
                                    />
                                  ) : (
                                    <>
                                      <span>
                                        <img
                                          src={getSvgCDNLinks(
                                            "mustUseGreenDot.svg",
                                          )}
                                          alt=""
                                        />
                                      </span>{" "}
                                      <span>Optional</span>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          )}

                          <div className="claimTypeText">
                            Sub-Type: <span>{component.subType}</span>
                          </div>
                          <div className="claimId">
                            PromoMats ID:{" "}
                            <span>
                              {!hideMustUseLabels &&
                                modulePreviewData?.countryName !==
                                  "United States" && (
                                  <OverlayPopOver
                                    element={
                                      <img
                                        src={getMlrStatusIcon(
                                          component?.mlrStatus,
                                        )}
                                        alt={component?.mlrStatus}
                                      />
                                    }
                                    overlayData={
                                      <ToolTipText>
                                        {component?.mlrStatus ||
                                          "Module not Published"}
                                      </ToolTipText>
                                    }
                                    trigger={["hover", "focus"]}
                                    placement="bottom"
                                    classId="tooltip"
                                    containerRef={popoverRef}
                                  />
                                )}
                              {component.componentDocNumber}
                            </span>
                          </div>
                        </div>
                        {hideMustUseLabels || onlyClaimCardsVisible
                          ? component.mlrStatus == "Available for Use" && (
                              <ApprovedComp />
                            )
                          : null}
                        {/* {onlyClaimCardsVisible && <ApprovedComp />} */}
                        {modulePreviewData?.countryName === "United States" && (
                          <div className="mlrStatus-Block">
                            <img
                              src={getMlrStatusIcon(component?.mlrStatus)}
                              alt={component?.mlrStatus}
                            />
                            <span style={{ marginLeft: "5px" }}>
                              {component?.mlrStatus}
                            </span>
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          ...((isSlide ||
                            onlyClaimCardsVisible ||
                            edtInfo?.showEdt) && {
                            width: "50px",
                          }),
                        }}
                      >
                        <img
                          style={{
                            ...((isSlide ||
                              onlyClaimCardsVisible ||
                              edtInfo?.showEdt) && {
                              width: "90%",
                            }),
                          }}
                          src={getSvgCDNLinks("modulePreviewArrow.svg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <ClaimDetailsBox component={component}>
                    {component.trackChangeValue && (
                      <div>
                        <span
                          className={
                            component.trackChangeValue === "new"
                              ? "newData"
                              : component.trackChangeValue === "old"
                                ? "newData oldData"
                                : ""
                          }
                        >
                          {component.trackChangeValue}
                        </span>
                      </div>
                    )}
                    <img
                      src={
                        component.componentUrl?.startsWith("http")
                          ? component.componentUrl
                          : `data:image/jpeg;base64,${component.componentUrl}`
                      }
                      alt=""
                      onError={(e) => {
                        console.error("Image failed to load:", e);
                      }}
                      className="mb-2 img-fluid"
                    />
                    {(component?.title || component?.matchText) &&
                    component.subType !== "Data Graphic" ? (
                      <>
                        <p className="captionText">TITLE</p>
                        <p className="mb-0 relatedText">
                          {component.matchText
                            ? component.matchText
                            : component.title}
                        </p>
                      </>
                    ) : (
                      <>
                        {component?.relatedClaims?.length > 0 && (
                          <p className="captionText">
                            RELATED CLAIMS ({component?.relatedClaims?.length})
                          </p>
                        )}
                        {component.relatedClaims?.map((item, index) => (
                          <div style={{ marginBottom: "20px" }} key={index}>
                            <SingleLinekeyValue
                              label="ID"
                              value={
                                <>
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      marginRight: "4px",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    <span className="mr-1">
                                      <OverlayPopOver
                                        element={
                                          <img
                                            src={getMlrStatusIcon(
                                              item.mlrStatus,
                                            )}
                                            alt={item.mlrStatus}
                                          />
                                        }
                                        overlayData={
                                          <ToolTipText>
                                            {item.mlrStatus
                                              ? item.mlrStatus
                                              : ""}
                                          </ToolTipText>
                                        }
                                        trigger={["hover", "focus"]}
                                        placement="bottom"
                                        classId="tooltip"
                                        containerRef={popoverRef}
                                      />
                                    </span>
                                  </div>
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {item?.claimName}
                                  </span>
                                  {item?.mlrStatus
                                    ?.trim()
                                    .toLowerCase()
                                    .includes("expired") && (
                                    <span
                                      className="Expired"
                                      style={{
                                        verticalAlign: "middle",
                                        marginBottom: "-2px",
                                      }}
                                    >
                                      Expired
                                    </span>
                                  )}
                                </>
                              }
                              inline={true}
                            />
                            <p
                              className="mb-0 claimText"
                              style={{ marginTop: "12px" }}
                            >
                              {item.matchText}
                            </p>
                            {item.footnotes && (
                              <>
                                <p className="captionText">FOOTNOTE</p>
                                <p className="mb-0 relatedText">
                                  {item.footnotes ? item.footnotes : ""}
                                </p>
                              </>
                            )}
                            {item.abbreviation && (
                              <>
                                <p className="captionText">Abbreviations</p>
                                <p className="mb-0 relatedText">
                                  {item.abbreviation ? item.abbreviation : ""}
                                </p>
                              </>
                            )}
                            {item.references?.length > 0 && (
                              <>
                                <p className="captionText">Reference</p>
                                <span className="relatedTextRef">
                                  {item.references?.map(
                                    (reference, refIndex) => (
                                      <span key={refIndex}>
                                        {refIndex + 1}.{reference.documentName}
                                      </span>
                                    ),
                                  )}
                                </span>
                              </>
                            )}
                          </div>
                        ))}
                        {component?.relatedReusableTexts?.length > 0 && (
                          <p className="captionText">
                            Related Reusable Texts (
                            {component?.relatedReusableTexts?.length})
                          </p>
                        )}
                        {component.relatedReusableTexts?.map(
                          (item, refIndex) => (
                            <div
                              style={{ marginBottom: "20px" }}
                              key={refIndex}
                            >
                              <SingleLinekeyValue
                                label="ID"
                                value={
                                  <>
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        marginRight: "4px",
                                        marginLeft: "3px",
                                      }}
                                    >
                                      <span className="mr-1">
                                        <OverlayPopOver
                                          element={
                                            <img
                                              src={getMlrStatusIcon(
                                                item.mlrStatus,
                                              )}
                                              alt={item.mlrStatus}
                                            />
                                          }
                                          overlayData={
                                            <ToolTipText>
                                              {item.mlrStatus
                                                ? item.mlrStatus
                                                : ""}
                                            </ToolTipText>
                                          }
                                          trigger={["hover", "focus"]}
                                          placement="bottom"
                                          classId="tooltip"
                                          containerRef={popoverRef}
                                        />
                                      </span>
                                    </div>
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {item.reusableTextName}
                                    </span>
                                    {item?.mlrStatus
                                      ?.trim()
                                      .toLowerCase()
                                      .includes("expired") && (
                                      <span
                                        className="Expired"
                                        style={{
                                          verticalAlign: "middle",
                                          marginBottom: "-2px",
                                        }}
                                      >
                                        Expired
                                      </span>
                                    )}
                                  </>
                                }
                                inline={true}
                              />
                              <p
                                className="mb-0 claimText"
                                style={{ marginTop: "12px" }}
                              >
                                {item.matchText}
                              </p>
                            </div>
                          ),
                        )}
                      </>
                    )}
                    {component.footnotes && (
                      <>
                        <p className="captionText">FOOTNOTE</p>
                        <p className="mb-0 relatedText">
                          {component.footnotes ? component.footnotes : ""}
                        </p>
                      </>
                    )}
                    {component.references?.length > 0 && (
                      <>
                        <p className="captionText">Reference</p>
                        <p className="relatedTextRef">
                          {component.references?.map((reference, refIndex) => (
                            <span key={refIndex}>
                              {refIndex + 1}.{reference.documentName}
                            </span>
                          ))}
                        </p>
                      </>
                    )}
                  </ClaimDetailsBox>
                </div>
              ))}
          </div>
          {modulePreviewData?.businessRulesTrackChanges && (
            <>
              <div>
                <span className="bsOld">Old</span>
              </div>
              <BusinessRulesPreview
                businessRules={
                  modulePreviewData?.businessRulesTrackChanges?.old
                }
                usageGuidelines={
                  modulePreviewData?.businessRulesTrackChanges
                    ?.usageGuidelines || ""
                }
                linksNotClickable={openedFromModal}
              />
            </>
          )}
          {(modulePreviewData?.businessRules?.length > 0 ||
            modulePreviewData?.usageGuidelines ||
            modulePreviewData?.businessRulesTrackChanges) && (
            <>
              {modulePreviewData?.businessRulesTrackChanges && (
                <div>
                  <span className="newData">New</span>
                </div>
              )}
              <BusinessRulesPreview
                businessRules={modulePreviewData?.businessRules}
                usageGuidelines={modulePreviewData?.usageGuidelines || ""}
                linksNotClickable={openedFromModal}
              />
            </>
          )}
        </div>
      </div>
      <style jsx>{`
        .selected-claim {
          background-color: rgba(32, 54, 98, 0.05);
          border-left: 3px solid #203662;
        }
        .checkbox-wrapper {
          position: relative;
          z-index: 10;
        }
      `}</style>
    </>
  );
}

export default ModulePreviewData;

const CheckBoxComponent = ({
  item,
  isSelected,
  handleSelectedItem,
  BulbIconWrapper,
  isComponentTrue = false,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const itemId = item?.claimId || item?.reusableTextId || item?.componentId;

  return (
    <div
      className="checkbox-wrapper"
      style={{
        display: "flex",
        // alignItems: "center",
        // marginTop: "3rem",
        justifyContent: "center",
        position: "relative",
        zIndex: 20,
      }}
    >
      <article>
        <div
          className={styles.bulbwrapper}
          style={{ bottom: isComponentTrue ? "-65px" : null }}
        >
          <StyledTooltip
            title={item?.reason || item?.elementRationale || ""}
            arrow
            placement="bottom-start"
          >
            <img src={bulbIcon} alt="Rational" />
          </StyledTooltip>
        </div>
      </article>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={(e) => {
          e.stopPropagation();
          // console.log("Checkbox changed for:", itemId);
          handleSelectedItem(itemId);
        }}
        className={styles.checkinput}
      />
    </div>
  );
};
const ApprovedComp = () => {
  return (
    <div className="p-2" style={{ borderRadius: "20px" }}>
      <span>
        <img className={styles.claimTicks} src={chackbox} alt="approved" />
      </span>
      <span style={{ fontWeight: "700" }}> Approved</span>
    </div>
  );
};

const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "#333",
    fontSize: "12px",
    padding: "8px 12px",
    borderRadius: "4px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.5",
    marginTop: "0px",
    marginBottom: "8px",
    boxShadow: "0px 0px 8px 0px #231F201F",
    width: "220px",
    height: "auto",
  },
  arrow: {
    color: "#fff",
    width: "35px",
    height: "12px",
    paddingLeft: "9px",
    borderWidth: "2px",
    borderColor: "#fff",
    transform: "scale(1)",
  },

  popper: {
    zIndex: 9999,
    '&[x-placement*="bottom"] .MuiTooltip-tooltip': {
      marginTop: "8px",
      marginBottom: "0px",
    },
    '&[x-placement*="top"] .MuiTooltip-tooltip': {
      marginTop: "0px",
      marginBottom: "8px",
    },
  },
})(Tooltip);
